import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import diagnosis from './modules/diagnosis';
import bikeInformation from './modules/bike-information';
import bikeConnect from './modules/bike-connect';
import bikeReport from './modules/bike-report';
import getters from './getters';
import ss from '@/utils/session-storage';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    diagnosis,
    bikeInformation,
    bikeConnect,
    bikeReport
  },
  mutations: {
    clearCache (state, data) {
      ss.clear();
      const bikeCacheData = {
        user: state.user,
        diagnosis: state.diagnosis,
        bikeInformation: state.bikeInformation,
        bikeConnect: state.bikeConnect,
        bikeReport: state.bikeReport
      };

      // [user, diagnosis, bikeInformation, bikeConnect, bikeReport]
      const getStateKey = Object.keys(bikeCacheData);

      for (const item of getStateKey) {
        // ex: Object.keys(bikeCacheData[item]) -> [diagnosis, bikeErrorList, isDisp, isLcm, modelOpenState]
        for (const key of Object.keys(bikeCacheData[item])) {
          // bikeCacheData[item][key] -> bikeCacheData[diagnosis][bikeErrorList]
          if (typeof bikeCacheData[item][key] === 'object') {
            // bikeCacheData[item][key] -> diagnosis: {...}
            for (let prop in bikeCacheData[item][key]) {
              if (key !== 'localStorageDeviceInfo') {
                bikeCacheData[item][key][prop] = ss.getItem(bikeCacheData[item][key][prop]);
              }
            }
          } else bikeCacheData[item][key] = ss.getItem(bikeCacheData[item][key]);
        }
      }
    }
  },
  getters
});

export default store;
